import { ChevronDownIcon } from "@heroicons/react/16/solid";
import useMenusStore from "../../../store/menusStore";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function Example() {
    const { menus, activeMenu, setActiveMenu } = useMenusStore();

    const isActive = (menu) => {
        return activeMenu ? activeMenu._id === menu._id : false;
    };

    return (
        <div>
            <div className="grid grid-cols-1 sm:hidden">
                {/* Use an "onChange" listener to set the active menu on mobile. */}
                <select
                    value={activeMenu ? activeMenu._id : menus[0]?._id}
                    aria-label="Select a menu"
                    className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                    onChange={(e) => {
                        const selected = menus.find(
                            (m) => m._id === e.target.value
                        );
                        if (selected) setActiveMenu(selected);
                    }}
                >
                    {menus.map((menu) => (
                        <option key={menu._id} value={menu._id}>
                            {menu.name}
                        </option>
                    ))}
                </select>
                <ChevronDownIcon
                    aria-hidden="true"
                    className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
                />
            </div>
            <div className="hidden sm:block">
                <nav
                    aria-label="menus"
                    className="isolate flex divide-x divide-gray-200 rounded-lg shadow"
                >
                    {menus.map((menu, menuIndex) => (
                        <div
                            key={menu.name}
                            aria-current={isActive(menu)}
                            className={classNames(
                                isActive(menu)
                                    ? "text-black font-bold"
                                    : "text-gray-500 hover:text-gray-700",
                                menuIndex === 0 ? "rounded-l-lg" : "",
                                menuIndex === menus.length - 1
                                    ? "rounded-r-lg"
                                    : "",
                                "group relative min-w-0 flex-1 overflow-hidden bg-white px-4 py-4 text-center text-lg hover:bg-gray-50 focus:z-10 hover:cursor-pointer max-w-96"
                            )}
                            onClick={() => setActiveMenu(menu)}
                        >
                            <span>{menu.name}</span>
                            <span
                                aria-hidden="true"
                                className={classNames(
                                    menu.current
                                        ? "bg-indigo-500"
                                        : "bg-transparent",
                                    "absolute inset-x-0 bottom-0 h-0.5"
                                )}
                            />
                        </div>
                    ))}
                </nav>
            </div>

            <div className="grid grid-cols-1 gap-4 mt-4 sm:grid-cols-2 lg:grid-cols-3"></div>
        </div>
    );
}
